<template>
    <el-dialog :title="title" :visible="showflag" :width="width" @close="closeDialog" :close-on-click-modal="false">
        <el-form ref="formValidate" :model="model" label-width="120px">
            <el-form-item label="项目id：" prop="top_pid">
                <span>{{model.top_pid}}</span>
            </el-form-item>
            <el-form-item label="日期：" prop="day">
                <span>{{model.day}}</span>
            </el-form-item>
            <el-form-item label="需巡检设备数量：" prop="device_count">
                <span>{{model.device_count}}</span>
            </el-form-item>
            <el-form-item label="实际巡检数量：" prop="device_count_yes">
                <span>{{model.device_count_yes}}</span>
            </el-form-item>
            <el-form-item label="未巡检数量：" prop="device_count_no">
                <span>{{model.device_count_no}}</span>
            </el-form-item>
            <el-form-item label="记录时间：" prop="add_time">
                <span>{{model.add_time}}</span>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button type="primary" @click="closeDialog" size="medium">关 闭</el-button>
        </div>
    </el-dialog>
</template>

<script>
import editutil from '@/libs/editutil'
import { saveModel } from '@/api/common'

export default {
    name: 'deviceInspectionReportInfo',
    mixins: [editutil],
    data() {
        return {
            model: {
                top_pid: '',
                day: '',
                device_count: '',
                device_count_yes: '',
                device_count_no: '',
                add_time: '',
            },
            getObj:{
                url:'/api/admin/deviceinspectionreport/info',
                data:{
                    key:'id',
                    value:''
                }
            },
            enu_name: [],
        };
    },
    methods: {}
};
</script>